import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _category = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    sortOrder: 'google.protobuf.DoubleValue',
};
var _createCategoryRequest = { category: '_category' };
var _createCategoryResponse = { category: '_category' };
var _deleteCategoryRequest = {};
var _deleteCategoryResponse = {};
var _getCategoryRequest = {};
var _getCategoryResponse = { category: '_category' };
var _listCategoriesRequest = {};
var _listCategoriesResponse = { categories: '_category' };
var _queryCategoriesRequest = {};
var _queryCategoriesResponse = { categories: '_category' };
var _updateCategoryRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    category: '_category',
};
var _updateCategoryResponse = { category: '_category' };
var _updateExtendedFieldsRequest = {};
var _updateExtendedFieldsResponse = { category: '_category' };
function resolveWixFaqCategoryV2CategoryServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/category',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/category',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/category',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/faq-server/v2/categories',
                destPath: '/v2/categories',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-categories',
                destPath: '/v2/draft-categories',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/faq-server/v2/categories',
                destPath: '/v2/categories',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-categories',
                destPath: '/v2/draft-categories',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/faq/v2/categories',
                destPath: '/v2/categories',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-categories',
                destPath: '/v2/draft-categories',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/faq/v2/categories',
                destPath: '/v2/categories',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/faq-server/v2/categories',
                destPath: '/v2/categories',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-categories',
                destPath: '/v2/draft-categories',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/faq-server/v2/categories',
                destPath: '/v2/categories',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-categories',
                destPath: '/v2/draft-categories',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/faq-server/v2/categories',
                destPath: '/v2/categories',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-categories',
                destPath: '/v2/draft-categories',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/faq-server/v2/categories',
                destPath: '/v2/categories',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-categories',
                destPath: '/v2/draft-categories',
            },
        ],
        _: [
            {
                srcPath: '/_api/faq-server/v2/categories',
                destPath: '/v2/categories',
            },
        ],
        'dev._base_domain_': [
            {
                srcPath: '/_api/faq-server/v2/categories',
                destPath: '/v2/categories',
            },
            {
                srcPath: '/_api/faq-server/v2/draft-categories',
                destPath: '/v2/draft-categories',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/faq-server/v2/draft-categories',
                destPath: '/v2/draft-categories',
            },
            {
                srcPath: '/_api/faq-server/v2/categories',
                destPath: '/v2/categories',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new Category. */
export function createCategory(payload) {
    var _a = serializer(_createCategoryRequest, { _category: _category }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createCategoryResponse, {
        _category: _category,
    }).fromJSON;
    function __createCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.category.v2.category',
            method: 'POST',
            methodFqn: 'wix.faq.category.v2.CategoryService.CreateCategory',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFaqCategoryV2CategoryServiceUrl({
                protoPath: '/v2/categories',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createCategory.fromReq = fromReq;
    __createCategory.__isAmbassador = true;
    return __createCategory;
}
/** Retrieves a single category by ID. */
export function getCategory(payload) {
    var _a = serializer(_getCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCategoryResponse, { _category: _category }).fromJSON;
    function __getCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.category.v2.category',
            method: 'GET',
            methodFqn: 'wix.faq.category.v2.CategoryService.GetCategory',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFaqCategoryV2CategoryServiceUrl({
                protoPath: '/v2/categories/{categoryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCategory.fromReq = fromReq;
    __getCategory.__isAmbassador = true;
    return __getCategory;
}
/**
 * Updates a category.
 *
 * Each time the category is updated, `revision` increments by 1.
 * The current `revision` must be specified when updating the category.
 * This ensures you're working with the latest category and prevents unintended overwrites.
 * Updates can be partial.
 */
export function updateCategory(payload) {
    var _a = serializer(_updateCategoryRequest, { _category: _category }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateCategoryResponse, {
        _category: _category,
    }).fromJSON;
    function __updateCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.category.v2.category',
            method: 'PATCH',
            methodFqn: 'wix.faq.category.v2.CategoryService.UpdateCategory',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFaqCategoryV2CategoryServiceUrl({
                protoPath: '/v2/categories/{category.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateCategory.fromReq = fromReq;
    __updateCategory.__isAmbassador = true;
    return __updateCategory;
}
/**
 * Deletes a category.
 *
 * Deleting a category permanently removes it from the site's FAQ page.
 * Questions that belong to the deleted category are also deleted.
 */
export function deleteCategory(payload) {
    var _a = serializer(_deleteCategoryRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteCategoryResponse, {}).fromJSON;
    function __deleteCategory(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.category.v2.category',
            method: 'DELETE',
            methodFqn: 'wix.faq.category.v2.CategoryService.DeleteCategory',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFaqCategoryV2CategoryServiceUrl({
                protoPath: '/v2/categories/{categoryId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteCategory.fromReq = fromReq;
    __deleteCategory.__isAmbassador = true;
    return __deleteCategory;
}
/** Retrieves a list of all categories. */
export function listCategories(payload) {
    var _a = serializer(_listCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listCategoriesResponse, {
        _category: _category,
    }).fromJSON;
    function __listCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.category.v2.category',
            method: 'GET',
            methodFqn: 'wix.faq.category.v2.CategoryService.ListCategories',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFaqCategoryV2CategoryServiceUrl({
                protoPath: '/v2/categories',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listCategories.fromReq = fromReq;
    __listCategories.__isAmbassador = true;
    return __listCategories;
}
/**
 * Retrieves a list of categories, given the provided paging, filtering, and sorting.
 *
 * For field support for filters, see [Categories V2: Supported Filters](https://dev.wix.com/docs/rest/business-management/faq-app/faq/category-v2/supported-filters-and-sorting).
 */
export function queryCategories(payload) {
    var _a = serializer(_queryCategoriesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryCategoriesResponse, {
        _category: _category,
    }).fromJSON;
    function __queryCategories(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.category.v2.category',
            method: 'POST',
            methodFqn: 'wix.faq.category.v2.CategoryService.QueryCategories',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFaqCategoryV2CategoryServiceUrl({
                protoPath: '/v2/categories/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryCategories.fromReq = fromReq;
    __queryCategories.__isAmbassador = true;
    return __queryCategories;
}
/** Updates extended fields of a category without incrementing `revision`. */
export function updateExtendedFields(payload) {
    var _a = serializer(_updateExtendedFieldsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateExtendedFieldsResponse, {
        _category: _category,
    }).fromJSON;
    function __updateExtendedFields(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.faq.category.v2.category',
            method: 'POST',
            methodFqn: 'wix.faq.category.v2.CategoryService.UpdateExtendedFields',
            migrationOptions: {
                optInTransformResponse: true,
            },
            url: resolveWixFaqCategoryV2CategoryServiceUrl({
                protoPath: '/v2/categories/{id}/update-extended-fields',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateExtendedFields.fromReq = fromReq;
    __updateExtendedFields.__isAmbassador = true;
    return __updateExtendedFields;
}
//# sourceMappingURL=http.impl.js.map